import React from "react";
import { ComingSoon } from "../ComingSoon";
import PaperCard from "../PaperCard";
import "./Home.css";

export const AcceptedPapers = () => {
  const researchPapers = [
    {
      paperID: 1571117494,
      title:
        "ACT360: An Efficient 360-Degree Action Detection and Summarization Framework for Mission-Critical Training and Debriefing",
      authors:
        "Aditi Tiwari and Klara Nahrstedt (University of Illinois Urbana-Champaign, USA)",
    },
    {
      paperID: 1571117573,
      title:
        "Comparing Business Models for Optimizing Turnover in Electric Vehicle Charging Stations",
      authors:
        "Bruno Rodrigues, Ferhat Arslan and Janis Joel Enzler (University of St. Gallen, Switzerland); Andrei Ciortea (University of St.Gallen, Switzerland); Bernhard Fässler (Illwerke vkw, Austria)",
    },
    {
      paperID: 1571122365,
      title:
        "Laqista: Serverless Cloud-Fog-Dew Computing Platform for Deep Learning Applications",
      authors:
        "Seiki Makino, Tadashi Okoshi and Jin Nakazawa (Keio University, Japan)",
    },
    {
      paperID: 1571125537,
      title:
        "radarTrack: Enhancing Ego-Vehicle Speed Estimation with Single-chip mmWave Radar",
      authors:
        "Argha Sen and Soham Chakraborty (Indian Institute of Technology Kharagpur, India); Soham Tripathy (IIT Kharagpur, India); Sandip Chakraborty (Indian Institute of Technology Kharagpur, India)",
    },
    {
      paperID: 1571125804,
      title:
        "Energy-Efficient Function Invocation Scheduling for Edge FaaS Platforms",
      authors:
        "Francesca Righetti and Biagio Cornacchia (University of Pisa, Italy); Gabriele Russo Russo (University of Rome Tor Vergata, Italy); Nicola Tonellotto (University of Pisa, Italy); Valeria Cardellini (University of Rome Tor Vergata, Italy); Carlo Vallati (University of Pisa, Italy)",
    },
    {
      paperID: 1571125912,
      title:
        "Iterative Recommendations based on Monte Carlo Sampling and Trust Estimation in Multi-Stage Vehicular Traffic Routing Games",
      authors:
        "Doris E M Brown, Venkata Sriram Siddhardh Nadendla and Sajal K. Das (Missouri University of Science and Technology, USA)",
    },
    {
      paperID: 1571125928,
      title:
        "EcoLens: Leveraging Multi-Objective Bayesian Optimization for Energy-Efficient Video Processing on Edge Devices",
      authors:
        "Benjamin Civjan (University of Illinois Urbana-Champaign, USA); Bo Chen (University of Illinois at Urbana-Champaign, USA); Rui-Xiao Zhang and Klara Nahrstedt (University of Illinois Urbana-Champaign, USA)",
    },
    {
      paperID: 1571125934,
      title:
        "Coordinated Thermal Safety Attack and Defense on EV Battery Management Systems",
      authors:
        "Moayad Altawalbeh, Richard T. Meyer and Shameek Bhattacharjee (Western Michigan University, USA)",
    },
    {
      paperID: 1571125945,
      title:
        "CaSCON: Cache-Assisted Service Composition Orchestration Leveraging NDN",
      authors:
        "Carlos A Barrios, Ethan Alker and Mohan J Kumar (Rochester Institute of Technology, USA)",
    },
    {
      paperID: 1571125964,
      title:
        "SCRAG: Social Computing-Based Retrieval Augmented Generation for Community Response Forecasting in Social Media Environments",
      authors:
        "Dachun Sun (University of Illinois Urbana-Champaign, USA); You Lyu (University of Illinois at Urbana-Champaign, USA); Jinning Li (University of Illinois Urbana-Champaign, USA); Yizhuo Chen, Tianshi Wang and Tomoyoshi Kimura (University of Illinois at Urbana-Champaign, USA); Tarek Abdelzaher (University of Illinois, Urbana Champaign, USA)",
    },
    {
      paperID: 1571126084,
      title:
        "Securing Federated Learning from Distributed Backdoor Attacks via Maximal Clique and Dynamic Reputation System",
      authors:
        "Priyesh Ranjan (Missouri University of Science and Technology, USA); Ashish Gupta (Birla Institute of Technology & Science, United Arab Emirates); Sajal K. Das (Missouri University of Science and Technology, USA)",
    },
    {
      paperID: 1571126086,
      title:
        "Fog-Cloud interpolation of urban monitoring data collected by LoRaWAN networks",
      authors:
        "Carmine Colarusso, Ida Falco and Eugenio Zimeo (University of Sannio, Italy)",
    },
    {
      paperID: 1571126113,
      title:
        "DigiGuide: A DT-based Occupant Guiding System for Optimizing Comfort and Energy Consumption",
      authors:
        "Jun Ma (Telecom SudParis, France); Roberto Yus (University of Maryland, Baltimore County, USA); Georgios Bouloukakis (Telecom SudParis, France)",
    },
    {
      paperID: 1571126186,
      title:
        "AVATAR: An Autonomy Aware Routing for On-demand Transit Applications",
      authors:
        "David Rogers, Samir Amitkumar Gupta, Jose Talusan and Ammar Bin Zulqarnain (Vanderbilt University, USA); Mirza Baig and Arti Ramesh (Nissan North America, Inc., USA); Natsu Takahashi and Naoki Kojo (Nissan Motor Co. Ltd., Japan); Abhishek Dubey (Vanderbilt University, USA)",
    },
    {
      paperID: 1571126193,
      title:
        "TRACE: Traffic Response Anomaly Capture Engine for Localization of Traffic Incidents",
      authors:
        "Ammar Bin Zulqarnain (Vanderbilt University, USA); Jacob Buckelew (USA); Jose Talusan, Ayan Mukhopadhyay and Abhishek Dubey (Vanderbilt University, USA)",
    },
    {
      paperID: 1571126205,
      title:
        "E2RespUNet: End-to-End Respiratory Signal Reconstruction and Rate Prediction Using a Unified Attention-Enhanced U-Net",
      authors:
        "Shadman Sakib and Gaurav Shinde (University of Maryland Baltimore County, USA); Emon Dey (University of Maryland, Baltimore County, USA); Nirmalya Roy (University of Maryland Baltimore County, USA)",
    },
    {
      paperID: 1571126401,
      title:
        "A Digital Twin Approach for Crowd Flow Modeling on Railway Station Platforms",
      authors:
        "Yu Yasuda, Tatsuya Amano and Hirozumi Yamaguchi (Osaka University, Japan)",
    },
    {
      paperID: 1571127245,
      title:
        "Cellular-based Indoor Localization with Adapted LLM and Label-aware Contrastive Learning",
      authors:
        "Ren Ozeki, Haruki Yonekura, Hamada Rizk and Hirozumi Yamaguchi (Osaka University, Japan)",
    },
    {
      paperID: 1571128197,
      title:
        "Generative Digital Twin for Predictive Modeling in Dynamic IoT Scenarios",
      authors:
        "Leonardo Ciabattini and Luca Sciullo (University of Bologna, Italy); Alberto De Marchi (University of the Bundeswehr Munich, Germany); Lorenzo Gigli, Luciano Bononi and Marco Di Felice (University of Bologna, Italy)",
    },
    {
      paperID: 1571128274,
      title:
        "Cosmos: A Novel Cost Model for Serverless Workflows in the 3D Compute Continuum",
      authors:
        "Cynthia Marcelino, Sebastian Gollhofer-Berger and Thomas Pusztai (TU Wien, Austria); Nastic Stefan (Distributed Systems Group, TU Wien, Austria)",
    },
    {
      paperID: 1571128289,
      title:
        "Towards Automated Controller Parameter Design in Cyber-Physical Systems: Improving Computational Cost",
      authors:
        "Marlon J Ares-Milián and Gregory Provan (University College Cork, Ireland); Marcos Quinones-Grueiro (Vanderbilt University, USA)",
    },
    {
      paperID: 1571128327,
      title:
        "Understanding State Social Anxiety in Virtual Social Interactions using Multimodal Wearable Sensing Indicators",
      authors:
        "Maria A. Larrazabal, Zhiyuan Wang, Mark Rucker and Emma R. Toner (University of Virginia, USA); Mehdi Boukhechba (Janssen Pharmaceutical Companies, USA); Bethany Teachman and Laura E Barnes (University of Virginia, USA)",
    },
  ];

  const industryPapers = [
    {
      paperID: 1571125511,
      title:
        "Secure Onboarding of Devices and Applications to a Smart Decentralized Ecosystem",
      authors:
        "Ali Amin and Tarek Zaarour (Dell Technologies, Ireland); Sean Og Murphy (University College Cork & Insight Centre for Data Analytics, Ireland); Ahmed Khalid (Dell Technologies, Ireland); Utz Roedig and Cormac J. Sreenan (University College Cork, Ireland)",
    },
    {
      paperID: 1571125620,
      title:
        "Unsupervised Induction Motor Anomaly Detection using a Deep Convolutional Autoencoder based on Multi-Sensor Data Fusion",
      authors:
        "Nobuo Kawaguchi, Yusuke Asai, Kazuma Kano, Kairi Takaki, Yuki Mori, Yuma Suzuki, KIsho Watanabe, Yuki Gushi, Shin Katayama, Kenta Urano and Takuro Yonezawa (Nagoya University, Japan); Shintaro Hashiguchi (TRUSCO NAKAYAMA Corporation, Japan)",
    },
    {
      paperID: 1571127648,
      title:
        "Digitization Methods for a Logistics Warehouse Towards Digital Twin-Driven Optimization",
      authors:
        "Andrea Visentin (University College Cork, Ireland); Marco Dalla (Insight RI Centre for Data Analytics, Ireland); Benjamin Provan-Bessell (Insight Centre for Data Analytics, Ireland); Barry O'Sullivan (University College Cork, Ireland)",
    },
  ];

  const lifeSec = [
    {
      paperID: 1571137410,
      title: "AI-driven Access Control System for Smart Factory Devices",
      authors:
        "Oleh Volodymyrovych Zaritskyi; Dmytro V. Shyrokorad; Joerg Abendroth; Antonis Mpantis; George Triantafyllou; Oscar Garcia Perales; Armando Aguayo Mendoza; Ravishankar Borgaonkar; Rosella Omana Mancilla",
    },
    {
      paperID: 1571138386,
      title:
        "Bolstering Up Smart Products Cybersecurity (Re-)Certification with Manufacturer's Evidence",
      authors:
        "Stefano Sebastio; Sreedevi Beena; Sara Nieves Matheu García; Roland Atoui; Antonio Skarmeta Gomez",
    },
    {
      paperID: 1571138882,
      title:
        "Anomaly detection tools for the Lifecycle Security of Smart Systems",
      authors:
        "Diego Argüello Ron; Armando Aguayo Mendoza; Oscar Garcia Perales; Antonis Mpantis; George Triantafyllou; Norbert Goetze; Rosella Omana Mancilla",
    },
    {
      paperID: 1571139169,
      title: "Machine Learning Based Trust Aggregation for IoT Systems",
      authors:
        "Pasindu Manisha Kuruppuarachchi; Alan McGibney; Susan Rea; Bernd Ludwig Wenning",
    },
    {
      paperID: 1571139703,
      title:
        "AI-Enhanced Static Analysis: Reducing False Alarms Using Large Language Models",
      authors:
        "George David Apostolidis; Ilias Kalouptsoglou; Miltiadis Siavvas; Dionysios Kehagias; Dimitrios Tzovaras",
    },
  ];

  const s3Pec = [
    {
      paperID: 1571138279,
      title:
        "Graph-Based Filtering to Prevent Prompt-Engineered LLM Training Data Leaks",
      authors:
        "Alan Barnett; Paul Barry; Sean Ahearne; Merry Globin; Colin Duggan",
    },
    {
      paperID: 1571138484,
      title: "A Secure Data Ecosystem Testbed",
      authors:
        "Indika Dhanapala; Tharindu Ranathunga; Sourabh Bharti; Alan McGibney; Susan Rea",
    },
    {
      paperID: 1571141166,
      title:
        "Differentially Private Federated Adversarial Learning for Robust Malware Detection in Internet of Health Things (IoHTs)",
      authors: "Mohamed Amjath; Shagufta Henna",
    },
    {
      paperID: 1571143729,
      title:
        "Contextual Intelligence for Anomaly Detection in Zero Trust based Architectures",
      authors: "Indika Dhanapala; Sourabh Bharti; Alan McGibney; Susan Rea",
    },
  ];

  const smartAgr = [
    {
      paperID: 1571139751,
      title:
        "A Spatiotemporal Generative AI Framework for Agronomic Forecasting using Semi-Supervised Learning on Remote Sensing Time-Series",
      authors: "Shagufta Henna; Mallikharjuna Rao Sakhamuri",
    },
    {
      paperID: 1571141352,
      title:
        "Leveraging Climate Change Data to Enhance FPO-Led Climate Risk Insurance and Smart Agriculture Practices: A Case Study from Chhattisgarh, India",
      authors:
        "Owen Chiweshe; Sudha Arlikatti; Raji Pushpalatha; Baker Matovu; Viness Milumbe Chikambwe",
    },
    {
      paperID: 1571142821,
      title:
        "Multi-source Data Integration and IoT-Based Sensing for Crop Yield Modelling and Optimisation",
      authors:
        "Temitope Odedeyi; Olalekan R Kolawole; Chike Ugoji; Toye Ayankanmi; Oziegbe Okhuoya; Ismail Rabbi; Kwaku Onwona-Hwesofour Asante; Izzat Darwazeh",
    },
    {
      paperID: 1571143121,
      title:
        "Water leaks management in precision agriculture: toward sustainable irrigation systems",
      authors: "Gabriele Cecchetti; Anna Lina Ruscelli",
    },
  ];

  const smartAida = [
    {
      paperID: 1571130508,
      title:
        "Towards a Framework for Intelligent Sampling: Comprehensive Review of Challenges, AI Techniques, and Tools",
      authors:
        "Lander Bonilla; Jon Aguirre-Usandizaga; Asier Garcia-Perez; María José López Osa; Idoia Murua Belacortu; Josu Diaz-de-Arcaya; Jordi Arjona Aroca; Ana Isabel Torre-Bastida; Raúl Miñón; Aitor Almeida",
    },
    {
      paperID: 1571135572,
      title: "Validating a Strategy Questionnaire for Data Monetization",
      authors: "Martin Loers; Dominik Royé",
    },
    {
      paperID: 1571143448,
      title: "Data Monetization Through Tailored Demand Representation",
      authors:
        "Eduardo Vyhmeister; Lorenzo Reyes-Bozo; Dimitrios Bikoulis; Panagiotis E. Kyziropoulos; Gabriel G. Castañé; Andrea Visentin",
    },
    {
      paperID: 1571143451,
      title:
        "A Tool for Fairness Assessment and Red-Lining Detection in AI Systems",
      authors:
        "Dimitrios Bikoulis; Panagiotis E. Kyziropoulos; Eduardo Vyhmeister; Gabriel G. Castañé; Andrea Visentin",
    },
  ];

  const smartSys = [
    {
      paperID: 1571139343,
      title: "Human Activity Recognition through Probabilistic Data Fusion",
      authors: "Farwa Batool; Giuseppe Lo Re; Marco Morana; Giuseppe Rizzo",
    },
    {
      paperID: 1571139574,
      title:
        "Large Language Model based Roundabout Dataset Augmentation for Trajectory Prediction",
      authors:
        "Xiaotong Zhou; Zhenhui Yuan; Yi Han; Tianhua Xu; Laurence T. Yang; Jiawei Wang",
    },
    {
      paperID: 1571141665,
      title:
        "A Hybrid Intelligent System for Personalized Recommendations in Offline Retail",
      authors:
        "Alessandra De Paola; Pierluca Ferraro; Sergio Imperiale; Giuseppe Lo Re",
    },
    {
      paperID: 1571141778,
      title:
        "Latency-Aware Placement of Microservices in the Cloud-to-Edge Continuum via Resource Scaling",
      authors: "Alberto Bertoncini; Alberto Ceselli; Christian Quadri",
    },
    {
      paperID: 1571143853,
      title: "Quantitative Metrics for Smart Spaces",
      authors: "Lakshmi Mohan; Vivek Menon; Bharat Jayaraman",
    },
    {
      paperID: 1571143854,
      title:
        "Short-Term Load Forecasting with Attentive Neural Processes: Adaptivity and Uncertainty Estimation",
      authors: "Ramin Soleimani; Seokhyun Chung; Dirk Pesch",
    },
    {
      paperID: 1571143855,
      title:
        "FreDDI: Frequency-Driven DNN Partitioning in Distributed Inference",
      authors: "Robert Viramontes; Azadeh Davoodi",
    },
    {
      paperID: 1571143856,
      title:
        "Dynamic Resource Allocation in Cloud-to-Things Continuum for Real-Time IoT Applications",
      authors:
        "Marco Pettorali; Francesca Righetti; Carlo Vallati; Sajal K. Das; Giuseppe Anastasi",
    },
    {
      paperID: 1571143857,
      title:
        "State-Based Modeling and Anomaly Detection in Industrial Systems Using DEVS",
      authors:
        "Ghena Barakat; Harshit Gupta; Luca D'Agati; Giuseppe Tricomi; Francesco Longo; Giovanni Merlino; Antonio Puliafito",
    },
    {
      paperID: 1571144282,
      title:
        "Video-on-Demand Prediction via Ensemble Load-Adjusted CNN-Random Forests",
      authors: "Emmanuel Kangogo Kimeli; Ruairí de Fréin",
    },
  ];

  const ssc = [
    {
      paperID: 1571135543,
      title:
        "Designing an Efficient Cloud-to-Things Continuum for Real-Time Mobile Applications",
      authors: "Marco Pettorali; Francesca Righetti; Giuseppe Anastasi",
    },
    {
      paperID: 1571137417,
      title: "Adaptive UWB Indoor Positioning System",
      authors: "Yousef Sultan; Sachin Sharma; Liam Barry; Somayeh Mohammady",
    },
    {
      paperID: 1571137935,
      title:
        "A Comparative Analysis of Machine Learning and PID Controllers for Implementing Adaptive Cruise Control in Autonomous Vehicles",
      authors:
        "Federico Bravetti; Luigi Borriello; Alex Testa; Manuel Andruccioli; Kelvin Olaiya; Roberto Girau",
    },
    {
      paperID: 1571139746,
      title:
        "Reconfigurable Distributed Model Predictive Control for Decentralized IT/OT Systems",
      authors:
        "Mohammad Ghavidel Vahid; Rida Maamoor; Luca D'Agati; Antonio Puliafito; Francesco Longo; Giovanni Merlino",
    },
    {
      paperID: 1571140111,
      title:
        "Decentralized traffic management through a hybrid incremental and federated learning approach",
      authors:
        "Ilenia Ficili; Giuseppe Tricomi; Giovanni Cicceri; Francesco Longo; Salvatore Vitabile; Antonio Puliafito",
    },
    {
      paperID: 1571141184,
      title:
        "Fast and Secure Service Continuity in the Edge-Cloud Continuum: A Study of TLS 1.3 Resumption and Post-Quantum Key Exchange",
      authors: "Lorenzo Catoni; Carlo Puliafito; Gianluca Dini",
    },
    {
      paperID: 1571142347,
      title:
        "Simulating realistic user mobility for mobile crowdsensing using TACSim: a performance study",
      authors: "Matteo Rontini; Christine Bassem; Federico Montori",
    },
    {
      paperID: 1571143040,
      title:
        "Mutable Blockchains in IoT-driven Sustainable Urban Planning: Challenges, and Analytical Modeling",
      authors:
        "Saeed Javanmardi; Marco Scarpa; Mohammad Shojafar; Salvatore Distefano; Giovanni Merlino",
    },
    {
      paperID: 1571143160,
      title:
        "Optimizing Coordinated Evacuation Route Planning Based on Linear Programming",
      authors: "Riku Nakao; Akihito Hiromori; Hamada Rizk; Hirozumi Yamaguchi",
    },
  ];

  return (
    <div className="form-page-layout">
      <h2 className="title">Accepted Papers</h2>
      <div className="form-layout">
        <h3>Research Track</h3>
        {researchPapers.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
      </div>
      <div className="form-layout">
        <h3>Industry Track</h3>
        {industryPapers.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h3>Workshops</h3>
        <h4>LIFESEC 2025</h4>
        {lifeSec.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h4>S3PEC 2025</h4>
        {s3Pec.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h4>SmartAgr 2025</h4>
        {smartAgr.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h4>SmartAIDA 2025</h4>
        {smartAida.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h4>SmartSys 2025</h4>
        {smartSys.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
        <h4>SSC 2025</h4>
        {ssc.map(function (data) {
          return <PaperCard props={data} />;
        })}{" "}
      </div>
    </div>
  );
};
